import IconMaps from '@assets/icon-maps.svg'
import IconMail from '@assets/icon-mail.svg'

interface RelationshipCenterProps {
  className?: string
}

export function RelationshipCenter({ className }: RelationshipCenterProps) {
  return (
    <div className={className}>
      <p className="text-sm font-bold text-v3-gray-400 md:text-base md:leading-[1.375rem]">
        Central de Relacionamento
      </p>

      <div>
        <div className="flex items-center gap-2 mb-4 md:mb-2">
          <IconMail />
          <span className="text-sm font-semibold text-v3-gray-300 md:text-lg md:font-normal md:leading-[1.375rem]">
            E-mail
          </span>
        </div>
        <p className="text-base font-bold leading-5 text-v3-gray-300 md:text-lg md:leading-[1.375rem]">
          contato@portalsolar.com.br
        </p>
      </div>

      <div>
        <div className="flex items-center gap-2 mb-4 md:mb-2">
          <IconMaps />
          <span className="text-sm font-semibold text-v3-gray-300 md:text-lg md:font-normal md:leading-[1.375rem]">
            Onde estamos
          </span>
        </div>
        <p className="text-base font-bold leading-5 text-v3-gray-300 md:text-lg md:leading-[1.375rem]">
          Rodovia Dr. Antônio Luiz Moura Gonzaga, 3339 - Bloco B, Sala 102 B -
          Rio Tavares Central<br></br>
          Florianópolis - SC, 88048-301
        </p>
      </div>
    </div>
  )
}
